import React, {PropsWithChildren} from 'react';
import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import Block from 'client/common/components/block';
import {BordomatikBox, CreativeBox} from 'client/common/types';

import {ALLOWED_PARAMETERS} from './utils';

const i18n = I18N.creatives.creativeSettings;
const b = b_.with('creative-settings-form');

type ParametersBlockProps = PropsWithChildren<{
    box: CreativeBox | BordomatikBox;
}>;

export default function ParametersBlock(props: ParametersBlockProps) {
    const {box, children} = props;

    return (
        <Block
            header={i18n.new.parameters.label}
            description={i18n.new.parameters.desc.replace('%s', ALLOWED_PARAMETERS[box.name].length.toString())}
        >
            <div className={b('parameters')}>
                {ALLOWED_PARAMETERS[box.name].map(parameter => {
                    const label = I18N.surveyStats.creativeStats.parameter[parameter];
                    
                    return <div className={b('parameter')} key={parameter}>{label}</div>;
                })}
            </div>
            {children}
        </Block>
    );
}